import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  ano: Yup.string().numero().nullable().required(mensagemPadrao)
})
